import React from 'react';
import NavBar from './components/NavBar';
import Home from './components/Home';

function App() {
  return (
    <main className="App">
      <NavBar />
      <Home />
    </main>
  );
}

export default App;
